import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from './User';

@Injectable()
export class UserService {
    constructor(private http: HttpClient) { }
    public buttonText;
    // getBtnTextLogin()
    // {
    //    this.buttonText = 'Logout';
    // }
    // getBtnTextLogout()
    // {
    //    this.buttonText = 'Login';
    // }
}


// WEBPACK FOOTER //
// C:/unnati/backup/latestWebCode29march/backup17-june-20/src/app/user.service.ts